<template>
    <div class="Page">
        <Header Act="3"></Header>
        <div class="MaxWid" v-if="isLoggedIn">
            <div class="QueryBtn MarTop">
                <div class="QueryBtnItem" :class="{Act:i ==1}" @click="goToRequirements">百姓巡常行作品提交</div>
            </div>
            <div class="Steps pc-only">
                <div class="StepsItem" :class="{Act:stepId ==1,ColorBlank:ThisPage>1}" @click="TogglePage(1)">1. 基本信息</div>
                <div class="StepsItem" :class="{Act:stepId ==2,ColorBlank:ThisPage>2}" @click="TogglePage(2)">2. 专业信息</div>
                <div class="StepsItem" :class="{Act:stepId ==3,ColorBlank:ThisPage>3}" @click="TogglePage(3)">3. 作品授权书</div>
            </div>
            <div class="mobile-steps mobile-only">
                <div class="mobile-step" :class="{active: stepId == 1}" @click="TogglePage(1)">1. 基本信息</div>
                <div class="mobile-step" :class="{active: stepId == 2}" @click="TogglePage(2)">2. 专业信息</div>
                <div class="mobile-step" :class="{active: stepId == 3}" @click="TogglePage(3)">3. 作品授权书</div>
            </div>
            <BasicInfo 
                v-if="stepId==1" 
                :Type="String(i)" 
                :initial-data="worksInfoData"
                @PageBtn="ToggleStep" 
                :PageDisabled="PageDisabled" 
                @child-click="ToggJia">
            </BasicInfo>
            <SpecialtyInfo 
                v-if="stepId==2" 
                :TypeId="i" 
                :id="CommId || ''"
                :initialData="worksInfoData"
                @PageBtn="ToggleStep" 
                :PageDisabled="PageDisabled" 
                @child-click="ToggJia">
            </SpecialtyInfo>
            <ReplenishInfo 
                v-if="stepId==3" 
                :TypeId="i" 
                :id="CommId || ''"
                :initialData="worksInfoData"
                @PageBtn="ToggleStep" 
                :PageDisabled="PageDisabled">
            </ReplenishInfo>
        </div>
        <!-- 添加登录弹窗 -->
        <el-dialog
            title="登录"
            :visible.sync="loginDialogVisible"
            width="400px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="true"
            :before-close="handleDialogClose"
            custom-class="login-dialog">
            <div class="login-form">
                <div class="login-tabs">
                    <button :class="{ active: activeTab === 'verifyCode' }" @click="activeTab = 'verifyCode'">验证码登录</button>
                    <button :class="{ active: activeTab === 'password' }" @click="activeTab = 'password'">密码登录</button>
                </div>
                
                <!-- 验证码登录 -->
                <div v-if="activeTab === 'verifyCode'" class="login-content">
                    <el-input v-model="mobile" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone"></el-input>
                    <div class="slider-container">
                        <div class="slider-mask" :style="{ width: sliderWidth + 'px' }"></div>
                        <div class="slider-button" 
                            :style="{ left: sliderLeft + 'px' }"
                            @mousedown="startSlide"
                            @touchstart="startSlide">
                            <i class="el-icon-arrow-right"></i>
                        </div>
                        <div class="slider-text">{{ sliderText }}</div>
                    </div>
                    <div class="captcha">
                        <el-input v-model="captcha" placeholder="请输入验证码" prefix-icon="el-icon-message"></el-input>
                        <button class="send-captcha-btn" 
                            :disabled="!isSliderVerified || !mobile"
                            @click="sendCaptcha">
                            发送验证码
                        </button>
                    </div>
                    <div class="checkbox">
                        <el-checkbox v-model="agreeTerms">
                            我已阅读并同意
                            <a href="javascript:void(0)" @click="goToHome">《用户协议》</a>
                            和
                            <a href="javascript:void(0)" @click="goToHome">《隐私协议》</a>
                        </el-checkbox>
                    </div>
                    <el-button type="primary" class="login-btn" @click="handleVerifyCodeLogin">登录</el-button>
                </div>
                
                <!-- 密码登录 -->
                <div v-if="activeTab === 'password'" class="login-content">
                    <el-input v-model="SetData.username" placeholder="请输入用户名" prefix-icon="el-icon-user"></el-input>
                    <el-input v-model="SetData.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
                    <div class="captcha">
                        <el-input v-model="SetData.code" placeholder="请输入验证码" prefix-icon="el-icon-key"></el-input>
                        <img :src="captchaUrl" class="captcha-img" @click="refreshCaptcha">
                    </div>
                    <div class="checkbox">
                        <el-checkbox v-model="agreeTerms">
                            我已阅读并同意
                            <a href="javascript:void(0)" @click="goToHome">《用户协议》</a>
                            和
                            <a href="javascript:void(0)" @click="goToHome">《隐私协议》</a>
                        </el-checkbox>
                    </div>
                    <el-button type="primary" class="login-btn" @click="handlePasswordLogin">登录</el-button>
                </div>
            </div>
        </el-dialog>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../../components/header/head.vue';
    import Footer from '../../components/header/footer.vue';
    import Banner from '../../components/banner/Banner.vue';
    import BasicInfo from '../../components/applyReg/BasicInfo.vue';
    import ReplenishInfo from '../../components/applyReg/ReplenishInfo.vue';
    import SpecialtyInfo from '../../components/applyReg/SpecialtyInfo.vue';
    export default {
        components: {Header,Footer,Banner,BasicInfo,ReplenishInfo,SpecialtyInfo},
        data() {
            return {
                i: 1,
                stepId: 1,
                ThisPage: 1,
                CommId: "",
                PageData: "",
                Agreement: false,
                AgreementData: "",
                PageDisabled: false,
                isEditMode: false,
                worksInfoData: null,
                loginDialogVisible: false,
                isLoggedIn: false,
                formData: {
                    basicInfo: null,
                    specialtyInfo: null
                },
                isMobile: false, // 是否为移动设备
                activeTab: 'verifyCode',
                mobile: '',
                captcha: '',
                isSliderVerified: false,
                sliderWidth: 0,
                sliderLeft: 0,
                sliderText: '拖动滑块验证',
                agreeTerms: false,
                SetData: {
                    username: '',
                    password: '',
                    code: ''
                },
                captchaUrl: '',
                closeByUser: false
            }
        },
        created() {
            // 检测设备类型
            this.checkDeviceType();
            // 监听窗口大小变化
            window.addEventListener('resize', this.checkDeviceType);
            
            // 检查登录状态
            const token = localStorage.getItem('token');
            this.isLoggedIn = !!token;

            // 如果未登录，直接显示登录弹窗
            if (!this.isLoggedIn) {
                this.loginDialogVisible = true;
            } else {
                // 已登录的逻辑
                this.stepId = 1; // 确保初始步骤为1
                this.ThisPage = 1; // 确保当前页面为1
                
                if(this.$route.query.id) {
                    this.i = this.$route.query.id;
                }
                if(this.$route.query.type) {
                    this.i = this.$route.query.type;
                }

                // 检查是否是编辑模式
                this.isEditMode = this.$route.query.isEdit === 'true';
                
                // 检查是否从成功提交页面返回
                const isFromSuccess = this.$route.query.fromSuccess === 'true';
                
                // 如果是从成功提交页面返回，或者是新建模式（非编辑），清除localStorage缓存
                if (isFromSuccess || !this.isEditMode) {
                    localStorage.removeItem('basicInfoData');
                    localStorage.removeItem('specialtyInfoData');
                    localStorage.removeItem('specialtyInfoTemp');
                }
                
                if (this.isEditMode) {
                    const worksInfo = localStorage.getItem('editWorksInfo');
                    if (worksInfo) {
                        this.worksInfoData = JSON.parse(worksInfo);
                        if (this.worksInfoData && this.worksInfoData.id) {
                            this.CommId = this.worksInfoData.id;
                        }
                        localStorage.removeItem('editWorksInfo');
                        localStorage.removeItem('isEdit');
                    }
                } else {
                    // 非编辑模式不需要恢复之前的表单数据，因为我们已经清除了缓存
                    // 注释掉原来的恢复逻辑
                    /*
                    // 非编辑模式，尝试恢复之前保存的表单数据
                    const savedBasicInfo = localStorage.getItem('basicInfoData');
                    const savedSpecialtyInfo = localStorage.getItem('specialtyInfoData');
                    
                    if (savedBasicInfo) {
                        this.formData.basicInfo = JSON.parse(savedBasicInfo);
                    }
                    if (savedSpecialtyInfo) {
                        this.formData.specialtyInfo = JSON.parse(savedSpecialtyInfo);
                    }
                    */
                }
            }
        },
        beforeDestroy() {
            // 移除窗口大小变化监听器
            window.removeEventListener('resize', this.checkDeviceType);
            // 清除localStorage中的临时数据
            if (!this.isEditMode) {
                localStorage.removeItem('basicInfoData');
                localStorage.removeItem('specialtyInfoData');
            }
        },
        methods: {
            // 检测设备类型
            checkDeviceType() {
                this.isMobile = window.innerWidth <= 768;
            },
            ToggJia(s){
                if(s==="next"){
                    this.stepId++,
                    this.ThisPage++
                }else{
                    this.stepId--,
                    this.ThisPage--
                }
                
            },
            ToggleStep(s, data) {
                // 无论是下一步还是上一步，都保存当前页面的数据
                if(this.stepId == 1){
                    // 保存基本信息到 localStorage
                    this.formData.basicInfo = {
                        userName: data.userName,
                        userPhone: data.userPhone,
                        userUnit: data.userUnit,
                        userUnitLevel: data.userUnitLevel,
                        userDept: data.userDept,
                        userZhiwu: data.userZhiwu,
                        userZhicheng: data.userZhicheng,
                        userEmail: data.userEmail,
                        userArea: data.userArea,
                        address: data.userArea,
                        userRegion: data.userRegion || []
                    };
                    localStorage.setItem('basicInfoData', JSON.stringify(this.formData.basicInfo));
                    
                    // 避免使用replace导航到当前页面，改为更新query参数
                    if (s === 'next') {
                        // 检查当前URL是否已经包含fromPrevious参数
                        const currentQuery = this.$route.query;
                        if (!currentQuery.fromPrevious) {
                        this.$router.replace({ 
                            query: { 
                                    ...currentQuery, 
                                fromPrevious: 'true'
                            }
                        });
                        }
                    }
                } else if(this.stepId == 2) {
                    // 保存专业信息到 localStorage
                    this.formData.specialtyInfo = {
                        projectCode: data.selectedThemeId || data.projectCode || '',
                        projectId: data.projectId || '',
                        projectCase: data.selectedTypes || data.projectCase || '',
                        worksType: data.worksType || '',
                        worksName: data.worksName || '',
                        workTime: data.workTime || '',
                        des: data.des || '',
                        workFile: data.workFile || '',
                        workPicFile: data.workPicFile || '',
                        workVedioFile: data.workVedioFile || '',
                        workJzFile: data.workJzFile || ''
                    };
                    localStorage.setItem('specialtyInfoData', JSON.stringify(this.formData.specialtyInfo));
                    
                    // 如果是点击上一步，重新保存基本信息，确保不会丢失
                    if (s === 'prve') {
                        const basicInfoData = localStorage.getItem('basicInfoData');
                        if (basicInfoData) {
                            try {
                                // 只是重新保存，确保数据不会因为时间过期而丢失
                                localStorage.setItem('basicInfoData', basicInfoData);
                            } catch (error) {
                                // 处理错误
                            }
                        }
                    }
                }

                // 然后再处理页面切换
                if(s == 'next'){
                    this.stepId = this.stepId + 1;
                    this.ThisPage = this.stepId;
                } else {
                    // 如果是点击上一步返回基本信息页，确保能够恢复数据
                    if (this.stepId == 2 && s == 'prve') {
                        const savedBasicInfo = localStorage.getItem('basicInfoData');
                        if (savedBasicInfo) {
                            try {
                                this.formData.basicInfo = JSON.parse(savedBasicInfo);
                                
                                // 检查当前URL是否已经包含fromPrevious参数
                                const currentQuery = this.$route.query;
                                if (!currentQuery.fromPrevious) {
                                    // 避免使用replace导航到当前页面
                                this.$router.replace({ 
                                    query: { 
                                            ...currentQuery, 
                                        fromPrevious: 'true'
                                    }
                                });
                                }
                            } catch (error) {
                                // 处理错误
                            }
                        }
                    }
                    this.stepId = this.stepId - 1;
                    this.ThisPage = this.stepId;
                }
            },
            ToggleNav(i) {
                if (!this.isLoggedIn) {
                    this.loginDialogVisible = true;
                    return;
                }
                this.i = i;
                this.stepId = 1;
                this.ThisPage = 1;
            },
            TogglePage(i) {
                if (!this.isLoggedIn) {
                    this.loginDialogVisible = true;
                    return;
                }
                this.stepId = i;
                if(i != this.ThisPage) {
                    this.PageDisabled = true;
                } else {
                    this.PageDisabled = false;
                }
            },
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
            checkLogin() {
                const token = localStorage.getItem('token');
                if (!token) {
                    this.loginDialogVisible = true;
                    return;
                }
                this.isLoggedIn = true;
                this.ToggleNav(1);
            },
            handleVerifyCodeLogin() {
                if (!this.agreeTerms) {
                    this.$message.error("请同意用户协议与隐私协议！");
                    return;
                }
                if (!this.captcha) {
                    this.$message.error("请输入验证码！");
                    return;
                }
                this.$post(`/loginSms?phoneNumber=${this.mobile}&code=${this.captcha}`).then((res) => {
                    if (res.data.code === 200) {
                        this.$auth.setToken(res.data.data);
                        this.$get('/getInfo').then(infoRes => {
                            if (infoRes.data.code === 200) {
                                this.$auth.setUserInfo(infoRes.data.user);
                                this.isLoggedIn = true;
                                this.$message.success('登录成功');
                                this.$bus.$emit('updateUser');
                                this.handleLoginSuccess();
                            }
                        }).catch(() => {
                            this.$message.error('登录失效，请重新登录');
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(() => {
                    this.$message.error('登录失败');
                });
            },
            handlePasswordLogin() {
                if (!this.SetData.username || !this.SetData.password || !this.SetData.code) {
                    this.$message.error("请填写完整信息！");
                    return;
                }
                if (!this.agreeTerms) {
                    this.$message.error("请同意用户协议与隐私协议！");
                    return;
                }
                const loginData = {
                    username: this.SetData.username,
                    password: this.SetData.password,
                    code: this.SetData.code,
                    uuid: this.SetData.uuid
                };
                this.$post('/login', loginData).then((res) => {
                    if (res.data.code === 200) {
                        this.$auth.setToken(res.data.token);
                        this.$get('/getInfo').then(infoRes => {
                            if (infoRes.data.code === 200) {
                                this.$auth.setUserInfo(infoRes.data.user);
                                this.isLoggedIn = true;
                                this.$message.success('登录成功');
                                this.$bus.$emit('updateUser');
                                this.handleLoginSuccess();
                            }
                        }).catch(() => {
                            this.$message.error('登录失效，请重新登录');
                        });
                    } else {
                        this.$message.error(res.data.msg);
                        this.refreshCaptcha();
                    }
                });
            },
            sendCaptcha() {
                if (!this.isSliderVerified) {
                    this.$message.warning("请先完成滑块验证");
                    return;
                }
                if (!this.mobile) {
                    this.$message.error("请输入手机号！");
                    return;
                }
                // 验证手机号格式
                if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
                    this.$message.error("请输入正确的手机号！");
                    return;
                }
                this.$post(`/smsSend?phoneNumber=${this.mobile}`).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success(res.data.msg || '验证码已发送，请查收！');
                    } else {
                        this.$message.error(res.data.msg || '验证码发送失败');
                    }
                    this.isSliderVerified = false;
                    this.sliderLeft = 0;
                    this.sliderWidth = 0;
                    this.sliderText = '请向右滑动验证';
                }).catch(() => {
                    this.$message.error('验证码发送失败');
                });
            },
            startSlide(e) {
                this.isDragging = true;
                this.startX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
                this.sliderStartLeft = this.sliderLeft; // 保存开始拖动时的位置
                
                // 添加全局鼠标事件监听
                document.addEventListener('mousemove', this.moveSlide);
                document.addEventListener('mouseup', this.endSlide);
                
                // 添加触摸事件支持
                document.addEventListener('touchmove', this.moveSlide, { passive: false });
                document.addEventListener('touchend', this.endSlide);
                
                // 防止触摸事件时页面滚动
                if (e.type === 'touchstart') {
                    e.preventDefault();
                }
            },
            
            moveSlide(e) {
                if (!this.isDragging) return;
                
                // 获取当前位置，支持鼠标和触摸事件
                const currentX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
                
                const containerWidth = 315; // 固定容器宽度
                const buttonWidth = 34; // 滑块宽度
                
                // 计算移动距离
                const deltaX = currentX - this.startX;
                let newLeft = this.sliderStartLeft + deltaX;
                
                // 限制滑动范围
                newLeft = Math.max(0, Math.min(newLeft, containerWidth - buttonWidth));
                
                this.sliderLeft = newLeft;
                this.sliderWidth = newLeft + buttonWidth;
                
                // 判断是否滑到末端（增加精确度要求）
                if (newLeft >= containerWidth - buttonWidth - 2) { // 只允许最后2px的误差
                    this.verifySlider();
                }
                
                // 防止触摸事件时页面滚动
                if (e.type === 'touchmove') {
                    e.preventDefault();
                }
            },
            
            endSlide() {
                this.isDragging = false;
                
                // 移除所有事件监听
                document.removeEventListener('mousemove', this.moveSlide);
                document.removeEventListener('mouseup', this.endSlide);
                document.removeEventListener('touchmove', this.moveSlide);
                document.removeEventListener('touchend', this.endSlide);
                
                // 如果没有验证成功，则回到起点
                if (!this.isSliderVerified) {
                    this.sliderLeft = 0;
                    this.sliderWidth = 0;
                } else {
                    // 如果验证成功，确保滑块到达终点
                    const containerWidth = 315;
                    const buttonWidth = 34;
                    this.sliderLeft = containerWidth - buttonWidth;
                    this.sliderWidth = containerWidth;
                }
            },
            
            verifySlider() {
                this.isSliderVerified = true;
                this.sliderText = '验证通过';
            },
            goToRegister() {
                this.loginDialogVisible = false;
                this.$router.push('/register');
            },
            goToHome() {
                this.loginDialogVisible = false;
                this.$router.push('/');
            },
            refreshCaptcha() {
                this.$get('/captchaImage').then((res) => {
                    if (res.data.code == 200) {
                        this.captchaUrl = "data:image/gif;base64," + res.data.img;
                        this.SetData.uuid = res.data.uuid;
                    }
                });
            },
            handleDialogClose(done) {
                this.$router.push('/requirements');
                done();
            },
            handleUserClose() {
                this.$router.push('/requirements');
            },
            handleLoginSuccess() {
                this.loginDialogVisible = false;
                this.isLoggedIn = true;
                this.stepId = 1;
                this.ThisPage = 1;
                
                // 清除之前的缓存数据
                localStorage.removeItem('basicInfoData');
                localStorage.removeItem('specialtyInfoData');
                localStorage.removeItem('specialtyInfoTemp');
            },
            goToRequirements() {
                this.$router.push('/requirements');
            }
        },
        watch: {
            activeTab(newVal) {
                if (newVal === 'password') {
                    this.refreshCaptcha();
                }
            }
        },
        provide() {
            return {
                worksInfo: () => this.worksInfoData,
                isEdit: () => this.isEditMode,
                isLoggedIn: () => this.isLoggedIn,
                formData: () => ({
                    basicInfo: this.formData.basicInfo,
                    specialtyInfo: this.formData.specialtyInfo
                })
            }
        }
    }
</script>
<style>
    .el-select-dropdown__item{
        text-align: center;
    }
    
    /* 默认隐藏移动端元素 */
    .mobile-only {
        display: none;
    }
    
    /* PC端默认显示 */
    .pc-only {
        display: block;
    }
</style>
<style scoped>
    /* PC端样式 */
    .Page {
        background: #fff;
    }
    .MaxHei{
        max-height: 500px;
        overflow: auto;
    }
    .BgColorBlue {
        background-color: #037dbe;
    }

    .BgColorYellow {
        background-color: #ed8404;
    }

    .BgColorGreen {
        background-color: #82ae1d;
    }
    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .QueryBtn{
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .QueryBtnItem{
        flex: 1;
        padding: 10px 0;
        text-align: center;
        border-bottom: 1px solid #ccc;
        font-weight: 400;
        font-size: 20px;
        color: #666666;
        cursor: pointer;
    }
    .QueryBtnItem:hover,
    .QueryBtnItem.Act{
        background-image: linear-gradient(to right, #2bcc9f 0%, #649ab9 100%);
        color: #fff;
    }
    .Steps{
        display: flex;
        align-items: center;
        margin: 30px 0;
    }
    .StepsItem{
        flex: 1;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #F5F5F5;
        position: relative;
        font-weight: 400;
        font-size: 18px;
        color: #999;
        cursor: pointer;
    }
    .StepsItem.ColorBlank{
        color: #000;
    }
    .StepsItem::after{
        content: "";
        border-top: 25px solid #fff;
        border-bottom: 25px solid #fff;
        border-left: 20px solid #F5F5F5;
        position: absolute;
        right: 0;
        top: 0;
    }
    .StepsItem::before{
        content: "";
        border-top: 25px solid transparent;
        border-bottom: 25px solid transparent;
        border-left: 20px solid #fff;
        position: absolute;
        left: 0;
        top: 0;
    }
    .StepsItem.Act{
        background: #58C1B6;
        color: #fff;
    }
    .StepsItem.Act::after{
        border-left: 20px solid #58C1B6;
    }
    .AgreementBtn{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    /* 移动端样式 */
    @media only screen and (max-width: 768px) {
        .pc-only {
            display: none;
        }
        .mobile-only {
            display: block;
        }
        .MaxWid {
            padding: 0 15px;
        }
        .QueryBtnItem {
            font-size: 16px;
            padding: 8px 0;
        }
        .mobile-steps {
            display: flex;
            margin: 20px 0;
            border-bottom: 1px solid #eee;
        }
        .mobile-step {
            flex: 1;
            text-align: center;
            padding: 10px 5px;
            font-size: 14px;
            color: #999;
            cursor: pointer;
            position: relative;
        }
        .mobile-step.active {
            color: #58C1B6;
            font-weight: bold;
        }
        .mobile-step.active::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: #58C1B6;
        }
    }

    /* 登录弹窗样式 */
    .login-dialog {
        border-radius: 8px;
    }

    .login-dialog :deep(.el-dialog__header) {
        padding: 20px;
        border-bottom: 1px solid #eee;
    }

    .login-dialog :deep(.el-dialog__title) {
        font-size: 18px;
        font-weight: bold;
        color: #333;
    }

    .login-dialog :deep(.el-dialog__headerbtn) {
        top: 20px;
        right: 20px;
    }

    .login-dialog :deep(.el-dialog__headerbtn .el-dialog__close) {
        font-size: 18px;
        color: #666;
    }

    .login-form {
        padding: 20px;
    }

    .login-tabs {
        display: flex;
        margin-bottom: 20px;
        border-bottom: 1px solid #eee;
    }

    .login-tabs button {
        flex: 1;
        padding: 10px;
        border: none;
        background: none;
        cursor: pointer;
        font-size: 16px;
        color: #666;
        position: relative;
    }

    .login-tabs button.active {
        color: #58C1B6;
    }

    .login-tabs button.active::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #58C1B6;
    }

    .login-content {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .login-content .el-input {
        margin-bottom: 0;
    }

    .slider-container {
        position: relative;
        width: 100%;
        height: 40px;
        background: #f5f5f5;
        border-radius: 4px;
        margin: 10px 0;
    }

    .slider-mask {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        background: #e8f7f6;
        border-radius: 4px;
        transition: width 0.1s;
    }

    .slider-button {
        position: absolute;
        width: 40px;
        height: 40px;
        background: white;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        transition: left 0.1s;
        z-index: 2;
    }

    .slider-text {
        position: absolute;
        width: 100%;
        text-align: center;
        line-height: 40px;
        color: #999;
        user-select: none;
    }

    .captcha {
        display: flex;
        gap: 10px;
    }

    .captcha .el-input {
        flex: 1;
    }

    .send-captcha-btn {
        padding: 0 15px;
        background: #58C1B6;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        white-space: nowrap;
    }

    .send-captcha-btn:disabled {
        background: #ccc;
        cursor: not-allowed;
    }

    .captcha-img {
        height: 40px;
        width: 100px;
        cursor: pointer;
        border-radius: 4px;
    }

    .checkbox {
        margin: 10px 0;
    }

    .checkbox a {
        color: #58C1B6;
        text-decoration: none;
    }

    .login-btn {
        width: 100%;
        padding: 12px;
        font-size: 16px;
        margin-top: 10px;
        background-color: #58C1B6 !important;
        border-color: #58C1B6 !important;
    }

    /* 移动端适配 */
    @media only screen and (max-width: 768px) {
        .login-dialog {
            width: 90% !important;
            margin: 0 auto;
        }
        
        .login-form {
            padding: 15px;
        }
        
        .login-tabs button {
            font-size: 14px;
            padding: 8px;
        }
        
        .send-captcha-btn {
            padding: 0 10px;
            font-size: 12px;
        }
    }

    /* 复选框相关样式 */
    .checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
        background-color: #58C1B6;
        border-color: #58C1B6;
    }
    
    .checkbox :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
        color: #58C1B6;
    }
    
    .checkbox :deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
        border-color: #58C1B6;
    }
    
    .checkbox :deep(.el-checkbox__inner:hover) {
        border-color: #58C1B6;
    }
    
    .checkbox :deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
        background-color: #58C1B6;
        border-color: #58C1B6;
    }
    
    .checkbox :deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner::before) {
        background-color: #fff;
    }
</style>